var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{staticStyle:{"margin":"40px auto 0"}},[_c('div',{staticClass:"toLogin"},[_c('h3',[_vm._v("密码重置成功，将在"),_c('span',[_vm._v(_vm._s(_vm.time))]),_vm._v("秒后返回登录页面.")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dfbdda7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Step4.vue
// module id = null
// module chunks = 